var sep = 'DomInspector: ';
var proxy = ['log', 'warn', 'error'];
var exportObj = {};
proxy.forEach(function (item) {
  exportObj[item] = function funcName() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }
    return console[item].call(this, sep + args[0], args[1] || '');
  };
});
export default exportObj;